const expectedViewTransitionErrorNames = new Set([
  'AbortError',
  'InvalidStateError',
  'TimeoutError',
])

export const ignoreExpectedViewTransitionError = (error: unknown) => {
  if (
    error instanceof Error &&
    expectedViewTransitionErrorNames.has(error.name)
  ) {
    return
  }

  throw error
}
